export const data = {
    computedStack: [],
    observersMap: new WeakMap(),
    computedDependenciesTracker: new WeakMap()
}
